import getParents from './get-parents';

/**
 * The idea is to show abbreviated content with a more link.
 * Clicking on 'more' will hide the abbreviated content and show
 * the full content with a 'less' link.
 * Expects a container with 2 sub elements, one hidden. Each sub
 * elements has a link (more/less).
 *
 * <span data-swap-less-more-container>
 *   <span data-less>
 *     abbreviated content
 *     <a data-swap-less-more href="#">more</a>
 *   </span>
 *   <span data-more class="hidden">
 *     full content
 *     <a data-swap-less-more href="#">less</a>
 *   </span>
 *
 */
export default function swapLessMore() {
  document
    .querySelectorAll('[data-swap-less-more]')
    .forEach(function (trigger) {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const container = getParents(
          trigger,
          '[data-swap-less-more-container]',
        )[0];
        const contentElements = container.querySelectorAll(
          '[data-less],[data-more]',
        );
        contentElements.forEach((el) => {
          el.classList.toggle('hidden');
        });
      });
    });
}
